import { useDispatch } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';

import { CountAmount, CountSelect, DownloadBtn, TotalAmount, CountAmountLeft, TotalPayAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDateSplit, SearchRange, SearchSelect, SearchSelectText, SearchBtn } from '../component/search/search';
import { useNavigate } from 'react-router-dom';
import { changeNum, convertDateFormat, datePickerCommonOpts, paintWeekendColors } from '../common/function';
import { getBrand } from '../../config/brand';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

// dayjs timezone 플러그인 활성화
dayjs.extend(utc);
dayjs.extend(timezone);

function SettlementDepositStay() {
    let dispatch = useDispatch()
    let navigate = useNavigate();
    const isFastBrand = getBrand().key === 'fast';
    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(30)
    const [loading, setLoading] = useState(true)
    const [spinner, setSpinner] = useState(false)

    const [listData, setListData] = useState([])
    const [listTrxData, setListTrxData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [reload, setReload] = useState(false)

    let tabList = ["익일", "즉결"]
    const [activeTab, setActiveTab] = useState("익일")

    useEffect(() => {
        dispatch(change_Current_Location("입금대기내역"))
        dispatch(changeHeaderTitle({
            mainTitle: "거래조회",
            subTitle: "상세정보"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    // 기간 포맷 - 시작일/종료일 개별 선택
    const startInputRef = useRef(null);
    const endInputRef = useRef(null);
    const startPickerRef = useRef(null);
    const endPickerRef = useRef(null);

    useEffect(() => {
        startPickerRef.current = new Litepicker({
            ...datePickerCommonOpts,
            element: startInputRef.current,
            setup: (picker) => {
                picker.on('render', paintWeekendColors);
                picker.on('selected', (date) => {
                    setPage(1)
                    setPreDate(date.format('YYYY-MM-DD'));
                });
            }
        });

        endPickerRef.current = new Litepicker({
            ...datePickerCommonOpts,
            element: endInputRef.current,
            setup: (picker) => {
                picker.on('render', paintWeekendColors);
                picker.on('selected', (date) => {
                    setPage(1)
                    setNextDate(date.format('YYYY-MM-DD'));
                });
            }
        });

        return () => {
            startPickerRef.current?.destroy();
            endPickerRef.current?.destroy();
        };
    }, []);

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState(dayjs().format('YYYY-MM-DD'))
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY-MM-DD'))

    useEffect(() => {
        setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])

    // 날짜를 설정하는 함수 (당일/전일/당월/전월 버튼에서 호출)
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        startPickerRef.current?.setDate(startDate);
        endPickerRef.current?.setDate(endDate);
        onSubmitSearch()
    };

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    // 영업자 포맷
    const select1 = ["전체", "가맹점", "지사", "총판", "대리점", "영업자1", "영업자2", "영업자3"]

    const [selectedValue, setSelectedValue] = useState("전체");
    const [selectedText, setSelectText] = useState("")

    const handleSelectChange = (event) => {
        const value = event.target.value;
        setSelectedValue(value);
    };

    const handleSelectTextChange = (event) => {
        const value = event.target.value;
        setSelectText(value);
    };

    useEffect(() => {
        ListData()
    }, [page, maxFirstPage, reload, preDate, nextDate, activeTab])

    const ListData = async () => {
        if (page === 1) setSpinner(true)
        await axios.get(process.env.REACT_APP_API + "/api/payout", {
            withCredentials: true,
            params: {
                page: page,
                limit: maxFirstPage,
                type: activeTab == "익일" ? "daily" : "realtime",
                startDate: preDate,
                endDate: nextDate,
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setListData(tmp?.data ?? [])
                if (page === 1) {
                    setListTrxData(tmp?.data?.payoutList ?? []);
                }
                else {
                    setListTrxData((prev) => [...prev, ...tmp?.data?.payoutList ?? []]);
                }
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
            setSpinner(false)
        }).catch(error => {
            console.error(error);
            // navigate("/");
        });
    }

    const tableHeaderData = [
        ...(activeTab === "즉결" ? [{ "no": 0, "text": "선택", "width": "50px", "textAlign": "center" }] : []),
        { "no": 1, "text": "정산일", "width": "85px", "textAlign": "center" },
        { "no": 11, "text": "MID", "width": "60px", "textAlign": "center", "flex": 1 },
        { "no": 3, "text": "가맹점명", "width": "80px", "textAlign": "center", "flex": 1.5 },
        { "no": 4, "text": "정산액", "width": "65px", "textAlign": "center", "flex": 1 },
        { "no": 12, "text": "최종 입금 예정액", "width": "65px", "textAlign": "center", "flex": 1 },
        { "no": 5, "text": "금액변경", "width": "100px", "textAlign": "center" },
        ...(isFastBrand ? [{ "no": 15, "text": "분할", "width": "100px", "textAlign": "center" }] : []),
        { "no": 6, "text": "예금주", "width": "60px", "textAlign": "center", "flex": 1 },
        { "no": 7, "text": "입금계좌", "width": "100px", "textAlign": "center", "flex": 1.5 },
        { "no": 8, "text": "은행", "width": "50px", "textAlign": "center", "flex": 0.8 },
        { "no": 14, "text": "결제타입", "width": "60px", "textAlign": "center", "flex": 0.8 },
        { "no": 13, "text": "지갑", "width": "45px", "textAlign": "center", "flex": 0.6 },
        { "no": 9, "text": "적요", "width": "40px", "textAlign": "center", "flex": 0.8 },
        { "no": 10, "text": "관리자메모", "width": "100px", "textAlign": "center", "flex": 2 },
    ];

    const [checkedIds, setCheckedIds] = useState([]);

    // 상계처리 모달 상태
    const [offsetModal, setOffsetModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [offsetData, setOffsetData] = useState({
        finalAmount: '', // 최종 금액 (사용자 입력)
        offsetMemo: ''
    });

    // 상계처리 이력 모달 상태
    const [offsetHistoryModal, setOffsetHistoryModal] = useState(false);
    const [offsetHistory, setOffsetHistory] = useState([]);
    const [payoutInfo, setPayoutInfo] = useState(null);

    // 계좌 분할 모달 상태
    const [splitModal, setSplitModal] = useState(false);
    const [selectedSplitRow, setSelectedSplitRow] = useState(null);
    const [splitData, setSplitData] = useState({
        firstMerchantName: '',
        firstBankCode: '',
        firstAccountNumber: '',
        firstAccountHolder: '',
        firstAmount: '',
        firstMemo: '',
        secondMerchantName: '',
        secondBankCode: '',
        secondAccountNumber: '',
        secondAccountHolder: '',
        secondAmount: '',
        secondMemo: '',
        splitReason: ''
    });
    const [availableAccounts, setAvailableAccounts] = useState([]);
    const [bankInfoList, setBankInfoList] = useState([]);

    // 분할 이력 모달 상태
    const [splitHistoryModal, setSplitHistoryModal] = useState(false);
    const [splitHistory, setSplitHistory] = useState([]);
    const [splitPayoutInfo, setSplitPayoutInfo] = useState(null);

    // 상계처리 모달 열기
    const openOffsetModal = (row) => {
        setSelectedRow(row);
        setOffsetData({
            finalAmount: row.requested_amount ? Math.floor(parseFloat(row.requested_amount)).toString() : '',
            offsetMemo: ''
        });
        setOffsetModal(true);
    };

    // 변경 금액 계산 (현재 금액 - 최종 금액)
    const calculateOffsetAmount = () => {
        const currentAmount = parseFloat(selectedRow?.requested_amount || 0);
        const finalAmount = parseFloat(offsetData.finalAmount || 0);
        return currentAmount - finalAmount;
    };

    // 상계처리 이력 조회
    const fetchOffsetHistory = async (payoutId) => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + '/api/payout/offset-log',
                {
                    params: { id: payoutId },
                    withCredentials: true
                }
            );

            if (response.data.code === 1000) {
                setPayoutInfo(response.data.data.payout_info);
                setOffsetHistory(response.data.data.offset_logs);
                setOffsetHistoryModal(true);
            } else {
                alert(response.data.msg || '상계처리 이력을 조회할 수 없습니다.');
            }
        } catch (error) {
            console.error('상계처리 이력 조회 오류:', error);
            alert('상계처리 이력을 조회하는 중 오류가 발생했습니다.');
        }
    };

    // 은행 정보 조회
    const fetchBankInfo = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + '/api/payout/bank-info',
                { withCredentials: true }
            );

            if (response.data.code === 1000) {
                setBankInfoList(response.data.data.bank_info || []);
            }
        } catch (error) {
            console.error('은행 정보 조회 오류:', error);
        }
    };

    // 분할 이력 조회
    const fetchSplitHistory = async (payoutId) => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + '/api/payout/split-data',
                {
                    params: { payoutId: payoutId },
                    withCredentials: true
                }
            );

            if (response.data.code === 1000) {
                setSplitPayoutInfo(response.data.data.split_data[0]);
                setSplitHistory(response.data.data.split_data);
                setSplitHistoryModal(true);
            } else {
                alert(response.data.msg || '분할 이력을 조회할 수 없습니다.');
            }
        } catch (error) {
            console.error('분할 이력 조회 오류:', error);
            alert('분할 이력을 조회하는 중 오류가 발생했습니다.');
        }
    };

    // 계좌 분할 모달 열기
    const openSplitModal = async (row) => {
        setSelectedSplitRow(row);
        setSplitData({
            firstMerchantName: row.co_nm || '',
            firstBankCode: row.bank_code || '',
            firstAccountNumber: row.account_number || '',
            firstAccountHolder: row.account_holder || '',
            firstAmount: '',
            firstMemo: '',
            secondMerchantName: row.co_nm || '',
            secondBankCode: '',
            secondAccountNumber: '',
            secondAccountHolder: '',
            secondAmount: '',
            secondMemo: '',
            splitReason: ''
        });

        // 은행 정보 조회 (한 번만)
        if (bankInfoList.length === 0) {
            await fetchBankInfo();
        }

        setSplitModal(true);
    };

    // 은행 코드를 은행명으로 변환
    const getBankName = (bankCode) => {
        const bank = bankInfoList.find(b => b.code === bankCode);
        return bank ? bank.bank_name : bankCode;
    };

    // trx_id 중복 체크 (분할된 데이터인지 확인)
    const isSplitData = (trxId) => {
        if (!listTrxData || !trxId || trxId === null || trxId === undefined || trxId === '') return false;
        const sameTrxIdCount = listTrxData.filter(item => item.trx_id === trxId).length;
        return sameTrxIdCount > 1;
    };

    // 분할 금액 계산 (자동 계산)
    const calculateSplitAmount = () => {
        const totalAmount = parseFloat(selectedSplitRow?.requested_amount || 0);
        const firstAmount = parseFloat(splitData.firstAmount || 0);
        const secondAmount = totalAmount - firstAmount;
        
        setSplitData(prev => ({
            ...prev,
            secondAmount: secondAmount > 0 ? secondAmount.toString() : ''
        }));
    };

    // 계좌 분할 실행
    const handleSplitSubmit = async () => {
        if (!splitData.firstMerchantName || !splitData.firstBankCode || !splitData.firstAccountNumber || !splitData.firstAccountHolder ||
            !splitData.secondMerchantName || !splitData.secondBankCode || !splitData.secondAccountNumber || !splitData.secondAccountHolder ||
            !splitData.firstAmount || !splitData.secondAmount) {
            alert('모든 필수 항목을 입력해주세요.');
            return;
        }

        const totalAmount = parseFloat(selectedSplitRow?.requested_amount || 0);
        const firstAmount = parseFloat(splitData.firstAmount);
        const secondAmount = parseFloat(splitData.secondAmount);

        // 금액 검증
        if (firstAmount <= 0 || secondAmount <= 0) {
            alert('분할 금액은 0보다 커야 합니다.');
            return;
        }

        if (Math.abs((firstAmount + secondAmount) - totalAmount) > 0.01) {
            alert('분할 금액의 합이 원본 금액과 일치하지 않습니다.');
            return;
        }

        // 확인 메시지
        if (!window.confirm(`계좌 분할을 진행하시겠습니까?\n\n원본 금액: ${changeNum(totalAmount)}\n첫 번째 계좌: ${splitData.firstMerchantName} - ${getBankName(splitData.firstBankCode)} - ${splitData.firstAccountNumber} (${splitData.firstAccountHolder}) - ${changeNum(firstAmount)}\n두 번째 계좌: ${splitData.secondMerchantName} - ${getBankName(splitData.secondBankCode)} - ${splitData.secondAccountNumber} (${splitData.secondAccountHolder}) - ${changeNum(secondAmount)}`)) {
            return;
        }

        try {
            const response = await axios.post(
                process.env.REACT_APP_API + '/api/payout/split-deposit-account',
                {
                    id: selectedSplitRow.id,
                    firstMerchantName: splitData.firstMerchantName,
                    firstBankCode: splitData.firstBankCode,
                    firstBankName: getBankName(splitData.firstBankCode),
                    firstAccountNumber: splitData.firstAccountNumber,
                    firstAccountHolder: splitData.firstAccountHolder,
                    firstAmount: firstAmount,
                    firstMemo: splitData.firstMemo,
                    firstCoId: selectedSplitRow.co_id,
                    firstCoNm: splitData.firstMerchantName,
                    secondMerchantName: splitData.secondMerchantName,
                    secondBankCode: splitData.secondBankCode,
                    secondBankName: getBankName(splitData.secondBankCode),
                    secondAccountNumber: splitData.secondAccountNumber,
                    secondAccountHolder: splitData.secondAccountHolder,
                    secondAmount: secondAmount,
                    secondMemo: splitData.secondMemo,
                    secondCoId: selectedSplitRow.co_id,
                    secondCoNm: splitData.secondMerchantName,
                    splitReason: splitData.splitReason || '계좌 분할'
                },
                { withCredentials: true }
            );

            if (response.data.code === 1000) {
                alert('계좌 분할이 완료되었습니다.');
                setSplitModal(false);
                // 데이터 새로고침
                ListData();
            } else {
                alert(response.data.msg || '계좌 분할 중 오류가 발생했습니다.');
            }
        } catch (error) {
            console.error('계좌 분할 오류:', error);
            alert('계좌 분할 중 오류가 발생했습니다.');
        }
    };

    // 상계처리 실행
    const handleOffsetSubmit = async () => {
        if (!offsetData.finalAmount || !offsetData.offsetMemo) {
            alert('최종 금액과 메모를 입력해주세요.');
            return;
        }

        const currentAmount = parseFloat(selectedRow?.requested_amount || 0);
        const finalAmount = parseFloat(offsetData.finalAmount);
        const offsetAmount = currentAmount - finalAmount;

        // 변경 금액이 0인 경우 처리
        if (offsetAmount === 0) {
            alert('변경할 금액이 없습니다. 최종 금액을 다시 확인해주세요.');
            return;
        }

        // 변경 금액 확인
        if (!window.confirm(`상계처리를 진행하시겠습니까?\n\n현재 금액: ${changeNum(currentAmount)}\n최종 금액: ${changeNum(finalAmount)}\n변경 금액: ${changeNum(offsetAmount)}`)) {
            return;
        }

        try {
            const response = await axios.post(
                process.env.REACT_APP_API + '/api/payout/update-deposit-expected',
                {
                    id: selectedRow.id,
                    offsetAmt: finalAmount, // 최종 금액을 전송
                    offsetMemo: offsetData.offsetMemo
                },
                { withCredentials: true }
            );

            if (response.data.code === 1000) {
                alert('상계처리가 완료되었습니다.');
                setOffsetModal(false);
                // 데이터 새로고침
                setReload(e => !e);
            } else {
                alert(response.data.msg || '상계처리 중 오류가 발생했습니다.');
            }
        } catch (error) {
            console.error('상계처리 오류:', error);
            alert('상계처리 중 오류가 발생했습니다.');
        }
    };

    useEffect(() => {
        let tableBodyData = [];
        if (listTrxData) {
            let list = listTrxData ?? []
            for (let i = 0; i < list.length; i++) {
                let data = list[i];

                let date = data.created_at.split(' ');
                let date1 = data.requested_at.split(' ');

                // 상계처리 여부 확인
                const hasOffset = data.offset_at !== null && data.offset_at !== undefined;
                // 분할된 데이터 여부 확인
                const isSplit = isSplitData(data.trx_id);
                const rowStyle = hasOffset ? { color: "#dc2626", fontWeight: "500" } : 
                                 isSplit ? { color: "#1e40af", fontWeight: "500" } : {};

                tableBodyData.push([
                    ...(activeTab === "즉결" ? [{
                        no: 0,
                        text: (
                            <input
                                type="checkbox"
                                checked={checkedIds.includes(data.id)}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setCheckedIds(prev => [...prev, data.id]);
                                    } else {
                                        setCheckedIds(prev => prev.filter(id => id !== data.id));
                                    }
                                }}
                            />
                        ),
                        width: "50px",
                        textAlign: "center",
                    }] : []),
                    { no: 1, text: date[0], width: "85px", textAlign: "center", style: rowStyle },
                    { no: 11, text: data.user_id || '', width: "60px", textAlign: "center", style: rowStyle, flex: 1 },
                    { no: 3, text: data.co_nm, width: "80px", textAlign: "left", style: rowStyle, flex: 1.5 },
                    { no: 4, text: changeNum(data.requested_amount), width: "65px", textAlign: "right", style: rowStyle, flex: 1 },
                    { no: 12, text: changeNum(data.final_amount ?? data.requested_amount), width: "65px", textAlign: "right", style: rowStyle, flex: 1 },
                    { 
                        no: 5, 
                        text: (
                            <div style={{ display: "flex", gap: "4px", justifyContent: "center", flexWrap: "wrap" }}>
                                <button
                                    className="btn btn-sm btn-warning"
                                    onClick={() => openOffsetModal(data)}
                                    style={{
                                        padding: "4px 8px",
                                        fontSize: "12px",
                                        borderRadius: "4px",
                                        border: hasOffset ? "1px solid #dc2626" : 
                                               isSplit ? "1px solid #1e40af" : "1px solid #f59e0b",
                                        backgroundColor: hasOffset ? "#fef2f2" : 
                                                        isSplit ? "#f0f4ff" : "#fbbf24",
                                        color: hasOffset ? "#dc2626" : 
                                               isSplit ? "#1e40af" : "#92400e",
                                        cursor: "pointer"
                                    }}
                                >
                                    {hasOffset ? "재상계" : "상계"}
                                </button>
                                <button
                                    className="btn btn-sm btn-info"
                                    onClick={() => fetchOffsetHistory(data.id)}
                                    style={{
                                        padding: "4px 8px",
                                        fontSize: "12px",
                                        borderRadius: "4px",
                                        border: hasOffset ? "1px solid #dc2626" : 
                                               isSplit ? "1px solid #1e40af" : "1px solid #0ea5e9",
                                        backgroundColor: hasOffset ? "#fef2f2" : 
                                                        isSplit ? "#f0f4ff" : "#38bdf8",
                                        color: hasOffset ? "#dc2626" : 
                                               isSplit ? "#1e40af" : "#0c4a6e",
                                        cursor: "pointer"
                                    }}
                                >
                                    이력
                                </button>
                            </div>
                        ),
                        width: "100px",
                        textAlign: "center"
                    },
                    ...(isFastBrand ? [{
                        no: 15,
                        text: (
                            <div style={{ display: "flex", gap: "4px", justifyContent: "center", flexWrap: "wrap" }}>
                                <button
                                    className="btn btn-sm btn-primary"
                                    onClick={() => openSplitModal(data)}
                                    style={{
                                        padding: "4px 8px",
                                        fontSize: "12px",
                                        borderRadius: "4px",
                                        border: "1px solid #1e40af",
                                        backgroundColor: "#1e40af",
                                        color: "#ffffff",
                                        cursor: "pointer"
                                    }}
                                >
                                    분할
                                </button>
                                {isSplit && (
                                    <button
                                        className="btn btn-sm btn-info"
                                        onClick={() => fetchSplitHistory(data.id)}
                                        style={{
                                            padding: "4px 8px",
                                            fontSize: "12px",
                                            borderRadius: "4px",
                                            border: "1px solid #1e40af",
                                            backgroundColor: "#f0f4ff",
                                            color: "#1e40af",
                                            cursor: "pointer"
                                        }}
                                    >
                                        이력
                                    </button>
                                )}
                            </div>
                        ),
                        width: "100px",
                        textAlign: "center"
                    }] : []),
                    { no: 6, text: data.account_holder, width: "60px", textAlign: "left", style: rowStyle, flex: 1 },
                    { no: 7, text: data.account_number, width: "100px", textAlign: "left", style: rowStyle, flex: 1.5 },
                    { no: 8, text: data.bank_name, width: "50px", textAlign: "left", style: rowStyle, flex: 0.8 },
                    { no: 14, text: data.payment_type || '-', width: "60px", textAlign: "center", style: rowStyle, flex: 0.8 },
                    { no: 13, text: data.merchant_deposit_yn ?? "-", width: "45px", textAlign: "center", flex: 0.6,
                        style: { ...rowStyle, color: data.merchant_deposit_yn === "예치" ? "#2563eb" : "#999" }
                    },
                    { no: 9, text: data.payout_memo, width: "40px", textAlign: "left", style: rowStyle, flex: 0.8 },
                    { no: 10, text: data.admin_memo || '', width: "100px", textAlign: "left", style: rowStyle, flex: 2 },
                ]);
            }
            setCombineData(tableBodyData);
        }
    }, [listTrxData, checkedIds, activeTab]); // ✅ checkedIds, activeTab 추가

    // 더보기 버튼
    const [moreBtn, setMoreBtn] = useState(false)

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 640) setMoreBtn(true)
            else setMoreBtn(false)
        };

        window.addEventListener('resize', handleResize);
        handleResize()

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const observerRef = useRef(null);
    useEffect(() => {
        if (combineData.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && listData.totCnt >= page * maxFirstPage) {
                // 바닥에 닿으면 페이지 증가
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [combineData]);


    const handleClickTab = (tabName) => {
        setActiveTab(tabName);
        setCheckedIds([]); // 탭 변경 시 선택 초기화
    };

    const excelBtn = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/payout/excel", {
            withCredentials: true,
            params: {
                startDate: preDate,
                endDate: nextDate,
            }
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                excelData(tmp?.data?.payoutList ?? [])
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const excelData = (exData) => {
        let arr = []

        if (exData) {
            for (let i = 0; i < exData.length; i++) {
                let t = exData[i]
                let date = t.created_at.split(' ');

                try {
                    arr.push({
                        "정산일": date[0],
                        "MID": t.user_id || '',
                        "가맹점명": t.co_nm,
                        "정산액": t.requested_amount,
                        "최종 입금 예정액": t.final_amount ?? t.requested_amount,
                        "예금주": t.account_holder,
                        "입금계좌": t.account_number,
                        "은행": t.bank_name,
                        "결제타입": t.payment_type || '-',
                        "지갑": t.merchant_deposit_yn ?? "-",
                        "적요": t.payout_memo,
                    })
                } catch (error) {
                    console.log(error);
                }
            }
        }
        Excel(arr)
    }

    const onSubmit = async () => {
        if (activeTab === "즉결") {
            // 즉결 탭: 선택된 ID들만 확정
            if (checkedIds.length === 0) {
                alert('확정할 항목을 선택해주세요.');
                return;
            }
            
            if (!window.confirm(`선택한 ${checkedIds.length}건을 입금확정 하시겠습니까?`)) {
                return;
            }
            
            await axios.post(process.env.REACT_APP_API + "/api/payout/confirm-self-realtime", {
                ids: checkedIds
            }, {
                withCredentials: true,
            }).then((response) => {
                let tmp = response?.data;
                console.log(tmp)
                if (tmp?.code < 2000) {
                    alert(`자체 즉결 정산 확정이 완료되었습니다. (${tmp?.data?.updatedCount || 0}건)`);
                    setCheckedIds([]); // 선택 초기화
                    setReload(e => !e);
                } else {
                    alert(tmp?.msg || '입금확정 중 오류가 발생했습니다.');
                }
            }).catch(error => {
                console.error(error);
                alert('입금확정 중 오류가 발생했습니다.');
            });
        } else {
            // 익일 탭: 기존 로직 (전체 확정)
            if (window.confirm("전체 입금확정 하시겠습니까?")) {
                await axios.post(process.env.REACT_APP_API + "/api/payout/confirm", {
                    startDate: preDate,
                    endDate: nextDate,
                }, {
                    withCredentials: true,
                }).then((response) => {
                    let tmp = response?.data;
                    console.log(tmp)
                    if (tmp?.code < 2000) {
                        setReload(e => !e);
                    }
                }).catch(error => {
                    console.error(error);
                });
            }
        }
    }

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDateSplit
                        startInputRef={startInputRef}
                        endInputRef={endInputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={true}
                        state={true}
                    />

                    {moreBtn && <SearchSelectText type={"영업자"} selectData={select1} handleSelectChange={handleSelectChange} selectedValue={selectedValue} handleSelectTextChange={handleSelectTextChange} selectedText={selectedText} btnText={"검색"} onClick={() => onSubmitSearch()} />}
                </form>
            </div>

            <div className="intro-y box intro-padding" >
                <div className="tabulator_sorting_wrap" style={{ flexDirection: "row", marginBottom: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {tabList.map((tab) => (
                            <button
                                key={tab}
                                className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                                onClick={() => handleClickTab(tab)}
                                style={{
                                    padding: "12px 10px 8px",
                                    fontSize: "14px",
                                    fontWeight: activeTab === tab ? "600" : "400",
                                    color: activeTab === tab ? "#222" : "#888",
                                    background: "transparent",
                                    border: "none",
                                    borderBottom: activeTab === tab ? "3px solid #3182F6" : "3px solid transparent",
                                    transition: "all 0.2s ease-in-out",
                                    cursor: "pointer"
                                }}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                    <div className='excel-disable' style={{ width: "auto" }}>
                        <CountAmountLeft tableBodyData={listData?.totCnt ?? 0} textAlign={"right"} />

                        <DownloadBtn text={"엑셀 다운로드"} onClick={excelBtn} />
                    </div>
                </div>
                <div style={{ width: "100%"}}>
                    <div className="button_wrap" style={{ marginTop: "0px" }}>
                        {/* <button onClick={() => { }} id="tabulator-html-filter-go" name="searchPayBtn" type="button" className="btn btn-primary searchPayBtn" style={{ height: "30px", marginRight:"10px" }}
                            disabled={activeTab === "익일" ? false : true}>전체선택</button> */}
                        <button onClick={() => { onSubmit() }} id="tabulator-html-filter-go" name="searchPayBtn" type="button" className="btn btn-primary searchPayBtn" style={{ height: "30px" }}
                            disabled={false}>
                            {activeTab === "즉결" ? "선택 확정" : "입금확정"}
                        </button>
                    </div>
                    <List
                        tableHeaderData={tableHeaderData}
                        tableBodyData={listTrxData ?? 0}
                        filter_tableBodyData={combineData}
                        page={page}
                        setPage={setPage}
                        maxFirstPage={maxFirstPage}
                        observerRef={observerRef}
                        nonePage={false}
                        scrollState={true}
                        spinner={spinner}
                        height={"700px"}
                    />
                </div>
            </div>

            {/* 상계처리 모달 */}
            {offsetModal && (
                <div className="modal-overlay" style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                }}>
                    <div className="modal-content" style={{
                        backgroundColor: "white",
                        borderRadius: "8px",
                        padding: "20px",
                        minWidth: "400px",
                        maxWidth: "500px",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                    }}>
                        <div className="modal-header" style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "20px",
                            paddingBottom: "10px",
                            borderBottom: "1px solid #e5e7eb"
                        }}>
                            <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>금액 변경</h3>
                            <button 
                                className="btn-close" 
                                onClick={() => setOffsetModal(false)}
                                style={{
                                    background: "none",
                                    border: "none",
                                    fontSize: "24px",
                                    cursor: "pointer",
                                    color: "#6b7280"
                                }}
                            >
                                ×
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group" style={{ marginBottom: "15px" }}>
                                <label style={{ 
                                    display: "block", 
                                    marginBottom: "5px", 
                                    fontWeight: "500",
                                    color: "#374151"
                                }}>
                                    가맹점명
                                </label>
                                <input 
                                    type="text" 
                                    value={selectedRow?.co_nm || ''} 
                                    disabled 
                                    className="form-control"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px",
                                        backgroundColor: "#f9fafb",
                                        color: "#6b7280"
                                    }}
                                />
                            </div>
                            <div className="form-group" style={{ marginBottom: "15px" }}>
                                <label style={{ 
                                    display: "block", 
                                    marginBottom: "5px", 
                                    fontWeight: "500",
                                    color: "#374151"
                                }}>
                                    상계 전 금액
                                </label>
                                <input 
                                    type="text" 
                                    value={changeNum(parseFloat(selectedRow?.requested_amount || 0))} 
                                    disabled 
                                    className="form-control"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px",
                                        backgroundColor: "#f9fafb",
                                        color: "#6b7280"
                                    }}
                                />
                            </div>
                            <div className="form-group" style={{ marginBottom: "15px" }}>
                                <label style={{ 
                                    display: "block", 
                                    marginBottom: "5px", 
                                    fontWeight: "500",
                                    color: "#374151"
                                }}>
                                    최종 금액 *
                                </label>
                                <input 
                                    type="text" 
                                    value={offsetData.finalAmount}
                                    onChange={(e) => {
                                        // 숫자만 입력받기 (소수점, 콤마 등 제거)
                                        const value = e.target.value.replace(/[^0-9]/g, '');
                                        setOffsetData({
                                            ...offsetData,
                                            finalAmount: value
                                        });
                                    }}
                                    className="form-control"
                                    placeholder="최종 금액을 입력하세요 (숫자만)"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px"
                                    }}
                                />
                            </div>
                            
                            {/* 변경 금액 미리보기 */}
                            {offsetData.finalAmount && (
                                <div className="form-group" style={{ 
                                    marginBottom: "15px",
                                    padding: "10px",
                                    backgroundColor: "#f8fafc",
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "4px"
                                }}>
                                    <div style={{ 
                                        display: "flex", 
                                        justifyContent: "space-between", 
                                        alignItems: "center",
                                        fontSize: "14px"
                                    }}>
                                        <span style={{ color: "#64748b" }}>변경 금액:</span>
                                        <span style={{ 
                                            fontWeight: "600",
                                            color: calculateOffsetAmount() > 0 ? "#dc2626" : "#059669"
                                        }}>
                                            {calculateOffsetAmount() > 0 ? "-" : "+"}{changeNum(Math.abs(calculateOffsetAmount()))}원
                                        </span>
                                    </div>
                                    <div style={{ 
                                        fontSize: "12px", 
                                        color: "#64748b", 
                                        marginTop: "4px"
                                    }}>
                                        {calculateOffsetAmount() > 0 ? "금액 감소" : "금액 증가"}
                                    </div>
                                </div>
                            )}
                            <div className="form-group" style={{ marginBottom: "20px" }}>
                                <label style={{ 
                                    display: "block", 
                                    marginBottom: "5px", 
                                    fontWeight: "500",
                                    color: "#374151"
                                }}>
                                    변경 사유 *
                                </label>
                                <textarea 
                                    value={offsetData.offsetMemo}
                                    onChange={(e) => setOffsetData({
                                        ...offsetData,
                                        offsetMemo: e.target.value
                                    })}
                                    className="form-control"
                                    placeholder="금액 변경 사유를 입력하세요"
                                    rows="3"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px",
                                        resize: "vertical"
                                    }}
                                />
                            </div>
                        </div>
                        <div className="modal-footer" style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                            paddingTop: "15px",
                            borderTop: "1px solid #e5e7eb"
                        }}>
                            <button 
                                className="btn btn-secondary" 
                                onClick={() => setOffsetModal(false)}
                                style={{
                                    padding: "8px 16px",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9fafb",
                                    color: "#374151",
                                    cursor: "pointer"
                                }}
                            >
                                취소
                            </button>
                            <button 
                                className="btn btn-primary" 
                                onClick={handleOffsetSubmit}
                                style={{
                                    padding: "8px 16px",
                                    border: "1px solid #3b82f6",
                                    borderRadius: "4px",
                                    backgroundColor: "#3b82f6",
                                    color: "white",
                                    cursor: "pointer"
                                }}
                            >
                                금액 변경
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* 상계처리 이력 모달 */}
            {offsetHistoryModal && (
                <div className="modal-overlay" style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                }}>
                    <div className="modal-content" style={{
                        backgroundColor: "white",
                        borderRadius: "8px",
                        padding: "20px",
                        minWidth: "600px",
                        maxWidth: "800px",
                        maxHeight: "80vh",
                        overflow: "auto",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                    }}>
                        <div className="modal-header" style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "20px",
                            paddingBottom: "10px",
                            borderBottom: "1px solid #e5e7eb"
                        }}>
                            <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>상계처리 이력</h3>
                            <button 
                                className="btn-close" 
                                onClick={() => setOffsetHistoryModal(false)}
                                style={{
                                    background: "none",
                                    border: "none",
                                    fontSize: "24px",
                                    cursor: "pointer",
                                    color: "#6b7280"
                                }}
                            >
                                ×
                            </button>
                        </div>
                        
                        {/* Payout 기본 정보 */}
                        {payoutInfo && (
                            <div style={{
                                backgroundColor: "#f8fafc",
                                padding: "15px",
                                borderRadius: "6px",
                                marginBottom: "20px",
                                border: "1px solid #e2e8f0"
                            }}>
                                <h4 style={{ margin: "0 0 10px 0", fontSize: "16px", color: "#374151" }}>기본 정보</h4>
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", fontSize: "14px" }}>
                                    <div><strong>가맹점명:</strong> {payoutInfo.co_nm}</div>
                                    <div><strong>현재 금액:</strong> {changeNum(payoutInfo.requested_amount)}원</div>
                                    <div><strong>상태:</strong> {payoutInfo.status}</div>
                                    <div><strong>Payout UID:</strong> {payoutInfo.payout_uid}</div>
                                </div>
                            </div>
                        )}

                        {/* 상계처리 이력 테이블 */}
                        <div style={{ marginBottom: "20px" }}>
                            <h4 style={{ margin: "0 0 15px 0", fontSize: "16px", color: "#374151" }}>상계처리 이력</h4>
                            {offsetHistory.length > 0 ? (
                                <div style={{ overflow: "auto", maxHeight: "400px" }}>
                                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
                                        <thead>
                                            <tr style={{ backgroundColor: "#f8fafc", borderBottom: "2px solid #e2e8f0" }}>
                                                <th style={{ padding: "10px", textAlign: "left", fontWeight: "600" }}>처리일시</th>
                                                <th style={{ padding: "10px", textAlign: "right", fontWeight: "600" }}>변경 전</th>
                                                <th style={{ padding: "10px", textAlign: "right", fontWeight: "600" }}>변경 후</th>
                                                <th style={{ padding: "10px", textAlign: "right", fontWeight: "600" }}>변경 금액</th>
                                                <th style={{ padding: "10px", textAlign: "left", fontWeight: "600" }}>사유</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {offsetHistory.map((log, index) => (
                                                <tr key={log.id} style={{ borderBottom: "1px solid #e2e8f0" }}>
                                                    <td style={{ padding: "10px" }}>
                                                        {(() => {
                                                            // 서버에서 UTC 시간으로 오는 것을 명시적으로 처리
                                                            const utcTime = log.offset_at + 'Z'; // UTC임을 명시
                                                            const koreanTime = new Date(utcTime).toLocaleString('ko-KR', {
                                                                timeZone: 'Asia/Seoul',
                                                                year: 'numeric',
                                                                month: '2-digit',
                                                                day: '2-digit',
                                                                hour: '2-digit',
                                                                minute: '2-digit',
                                                                second: '2-digit',
                                                                hour12: false
                                                            });
                                                            
                                                            console.log('=== UTC → 한국시간 변환 ===');
                                                            console.log('서버 UTC 시간:', log.offset_at);
                                                            console.log('UTC 명시:', utcTime);
                                                            console.log('한국시간 변환:', koreanTime);
                                                            console.log('============================');
                                                            
                                                            return koreanTime;
                                                        })()}
                                                    </td>
                                                    <td style={{ padding: "10px", textAlign: "right" }}>
                                                        {changeNum(log.offset_before)}원
                                                    </td>
                                                    <td style={{ padding: "10px", textAlign: "right" }}>
                                                        {changeNum(log.offset_after)}원
                                                    </td>
                                                    <td style={{ 
                                                        padding: "10px", 
                                                        textAlign: "right",
                                                        color: log.offset_after < log.offset_before ? "#dc2626" : "#059669",
                                                        fontWeight: "600"
                                                    }}>
                                                        {log.offset_after < log.offset_before ? "-" : "+"}{changeNum(Math.abs(log.offset_after - log.offset_before))}원
                                                    </td>
                                                    <td style={{ padding: "10px" }}>
                                                        {log.offset_memo || "-"}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div style={{ 
                                    textAlign: "center", 
                                    padding: "40px", 
                                    color: "#6b7280",
                                    backgroundColor: "#f9fafb",
                                    borderRadius: "6px"
                                }}>
                                    상계처리 이력이 없습니다.
                                </div>
                            )}
                        </div>

                        <div className="modal-footer" style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            paddingTop: "15px",
                            borderTop: "1px solid #e5e7eb"
                        }}>
                            <button 
                                className="btn btn-secondary" 
                                onClick={() => setOffsetHistoryModal(false)}
                                style={{
                                    padding: "8px 16px",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9fafb",
                                    color: "#374151",
                                    cursor: "pointer"
                                }}
                            >
                                닫기
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* 계좌 분할 모달 */}
            {splitModal && (
                <div className="modal-overlay" style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000
                }}>
                    <div className="modal-content" style={{
                        backgroundColor: "white",
                        borderRadius: "8px",
                        padding: "20px",
                        minWidth: "500px",
                        maxWidth: "600px",
                        maxHeight: "80vh",
                        overflow: "auto",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                    }}>
                        <div className="modal-header" style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "20px",
                            paddingBottom: "10px",
                            borderBottom: "1px solid #e5e7eb"
                        }}>
                            <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>계좌 분할</h3>
                            <button 
                                className="btn-close" 
                                onClick={() => setSplitModal(false)}
                                style={{
                                    background: "none",
                                    border: "none",
                                    fontSize: "24px",
                                    cursor: "pointer",
                                    color: "#6b7280"
                                }}
                            >
                                ×
                            </button>
                        </div>

                        {selectedSplitRow && (
                            <div style={{ 
                                backgroundColor: "#f0f9ff", 
                                padding: "16px", 
                                borderRadius: "6px", 
                                marginBottom: "20px" 
                            }}>
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                                    <div><strong>가맹점명:</strong> {selectedSplitRow.co_nm}</div>
                                    <div><strong>원본 금액:</strong> {changeNum(selectedSplitRow.requested_amount)}원</div>
                                </div>
                            </div>
                        )}

                        <div style={{ display: "grid", gap: "20px" }}>
                            {/* 첫 번째 계좌 */}
                            <div>
                                <h4 style={{ marginBottom: "12px", color: "#374151", fontSize: "16px" }}>
                                    첫 번째 계좌 (기존 계좌 정보)
                                </h4>
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "12px" }}>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            가맹점명 *
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.firstMerchantName}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, firstMerchantName: e.target.value }))}
                                            placeholder="가맹점명을 입력하세요"
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        />
                                        <small style={{ color: "#6b7280", fontSize: "12px" }}>기존 가맹점명이 미리 입력됩니다</small>
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            은행 선택 *
                                        </label>
                                        <select
                                            value={splitData.firstBankCode}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, firstBankCode: e.target.value }))}
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        >
                                            <option value="">은행을 선택하세요</option>
                                            {bankInfoList.map(bank => (
                                                <option key={bank.code} value={bank.code}>
                                                    {bank.bank_name}
                                                </option>
                                            ))}
                                        </select>
                                        <small style={{ color: "#6b7280", fontSize: "12px" }}>기존 은행이 미리 선택됩니다</small>
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            계좌번호 *
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.firstAccountNumber}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, firstAccountNumber: e.target.value }))}
                                            placeholder="계좌번호를 입력하세요"
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        />
                                        <small style={{ color: "#6b7280", fontSize: "12px" }}>기존 계좌번호가 미리 입력됩니다</small>
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            예금주 *
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.firstAccountHolder}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, firstAccountHolder: e.target.value }))}
                                            placeholder="예금주명을 입력하세요"
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        />
                                        <small style={{ color: "#6b7280", fontSize: "12px" }}>기존 예금주명이 미리 입력됩니다</small>
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            분할 금액 *
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.firstAmount}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/[^0-9]/g, '');
                                                setSplitData(prev => ({ ...prev, firstAmount: value }));
                                                // 두 번째 금액 자동 계산
                                                setTimeout(() => {
                                                    const totalAmount = parseFloat(selectedSplitRow?.requested_amount || 0);
                                                    const firstAmount = parseFloat(value || 0);
                                                    const secondAmount = totalAmount - firstAmount;
                                                    setSplitData(prev => ({
                                                        ...prev,
                                                        secondAmount: secondAmount > 0 ? secondAmount.toString() : ''
                                                    }));
                                                }, 0);
                                            }}
                                            placeholder="첫 번째 계좌 분할 금액을 입력하세요 (숫자만)"
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            메모
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.firstMemo}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, firstMemo: e.target.value }))}
                                            placeholder="첫 번째 계좌 메모"
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* 두 번째 계좌 */}
                            <div>
                                <h4 style={{ marginBottom: "12px", color: "#374151", fontSize: "16px" }}>두 번째 계좌</h4>
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "12px" }}>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            가맹점명 *
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.secondMerchantName}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, secondMerchantName: e.target.value }))}
                                            placeholder="가맹점명을 입력하세요"
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            은행 선택 *
                                        </label>
                                        <select
                                            value={splitData.secondBankCode}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, secondBankCode: e.target.value }))}
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        >
                                            <option value="">은행을 선택하세요</option>
                                            {bankInfoList.map(bank => (
                                                <option key={bank.code} value={bank.code}>
                                                    {bank.bank_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            계좌번호 *
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.secondAccountNumber}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, secondAccountNumber: e.target.value }))}
                                            placeholder="계좌번호를 입력하세요"
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            예금주 *
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.secondAccountHolder}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, secondAccountHolder: e.target.value }))}
                                            placeholder="예금주명을 입력하세요"
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            분할 금액 (자동 계산)
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.secondAmount}
                                            readOnly
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px",
                                                backgroundColor: "#f9fafb",
                                                color: "#6b7280"
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                            메모
                                        </label>
                                        <input
                                            type="text"
                                            value={splitData.secondMemo}
                                            onChange={(e) => setSplitData(prev => ({ ...prev, secondMemo: e.target.value }))}
                                            placeholder="두 번째 계좌 메모"
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "4px",
                                                fontSize: "14px"
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* 분할 사유 */}
                            <div>
                                <label style={{ display: "block", marginBottom: "4px", fontWeight: "500" }}>
                                    분할 사유
                                </label>
                                <input
                                    type="text"
                                    value={splitData.splitReason}
                                    onChange={(e) => setSplitData(prev => ({ ...prev, splitReason: e.target.value }))}
                                    placeholder="계좌 분할 사유를 입력하세요"
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "4px",
                                        fontSize: "14px"
                                    }}
                                />
                            </div>
                        </div>

                        <div className="modal-footer" style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "8px",
                            paddingTop: "20px",
                            borderTop: "1px solid #e5e7eb",
                            marginTop: "20px"
                        }}>
                            <button 
                                className="btn btn-secondary" 
                                onClick={() => setSplitModal(false)}
                                style={{
                                    padding: "8px 16px",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9fafb",
                                    color: "#374151",
                                    cursor: "pointer"
                                }}
                            >
                                취소
                            </button>
                            <button 
                                className="btn btn-primary" 
                                onClick={handleSplitSubmit}
                                style={{
                                    padding: "8px 16px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#10b981",
                                    color: "white",
                                    cursor: "pointer"
                                }}
                            >
                                계좌 분할
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* 분할 이력 모달 */}
            {splitHistoryModal && (
                <div className="modal-overlay" style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1000
                }}>
                    <div className="modal-content" style={{
                        backgroundColor: "white",
                        borderRadius: "8px",
                        padding: "20px",
                        maxWidth: "800px",
                        width: "90%",
                        maxHeight: "80vh",
                        overflow: "auto",
                        boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)"
                    }}>
                        <div className="modal-header" style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "20px",
                            paddingBottom: "10px",
                            borderBottom: "1px solid #e5e7eb"
                        }}>
                            <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>분할 이력</h3>
                            <button 
                                className="btn-close" 
                                onClick={() => setSplitHistoryModal(false)}
                                style={{
                                    background: "none",
                                    border: "none",
                                    fontSize: "24px",
                                    cursor: "pointer",
                                    color: "#6b7280"
                                }}
                            >
                                ×
                            </button>
                        </div>

                        {/* 분할 정보 */}
                        {splitPayoutInfo && (
                            <div style={{ marginBottom: "20px", padding: "15px", backgroundColor: "#f8fafc", borderRadius: "6px" }}>
                                <h4 style={{ margin: "0 0 10px 0", fontSize: "16px", color: "#374151" }}>분할 정보</h4>
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", fontSize: "14px" }}>
                                    <div><strong>분할 사유:</strong> {splitPayoutInfo.split_reason}</div>
                                    <div><strong>분할 일시:</strong> {new Date(splitPayoutInfo.split_created_at).toLocaleString('ko-KR', { timeZone: 'Asia/Seoul' })}</div>
                                </div>
                            </div>
                        )}

                        {/* 분할 이력 테이블 */}
                        <div style={{ marginBottom: "20px" }}>
                            <h4 style={{ margin: "0 0 15px 0", fontSize: "16px", color: "#374151" }}>분할 계좌 상세</h4>
                            {splitHistory.length > 0 ? (
                                <div style={{ overflow: "auto", maxHeight: "400px" }}>
                                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
                                        <thead>
                                            <tr style={{ backgroundColor: "#f8fafc", borderBottom: "2px solid #e2e8f0" }}>
                                                <th style={{ padding: "12px", textAlign: "left", fontWeight: "600", color: "#374151" }}>구분</th>
                                                <th style={{ padding: "12px", textAlign: "left", fontWeight: "600", color: "#374151" }}>가맹점명</th>
                                                <th style={{ padding: "12px", textAlign: "left", fontWeight: "600", color: "#374151" }}>은행</th>
                                                <th style={{ padding: "12px", textAlign: "left", fontWeight: "600", color: "#374151" }}>계좌번호</th>
                                                <th style={{ padding: "12px", textAlign: "right", fontWeight: "600", color: "#374151" }}>금액</th>
                                                <th style={{ padding: "12px", textAlign: "left", fontWeight: "600", color: "#374151" }}>메모</th>
                                                <th style={{ padding: "12px", textAlign: "center", fontWeight: "600", color: "#374151" }}>상태</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {splitHistory.map((log, index) => (
                                                <tr key={index} style={{ borderBottom: "1px solid #e5e7eb" }}>
                                                    <td style={{ padding: "12px", fontWeight: "500", color: "#1e40af" }}>첫 번째</td>
                                                    <td style={{ padding: "12px" }}>{log.first_co_nm || '-'}</td>
                                                    <td style={{ padding: "12px" }}>{getBankName(log.first_bank_code)}</td>
                                                    <td style={{ padding: "12px" }}>{log.first_account_number || '-'}</td>
                                                    <td style={{ padding: "12px", textAlign: "right", fontWeight: "500" }}>{changeNum(log.first_amount)}원</td>
                                                    <td style={{ padding: "12px" }}>{log.first_memo || '-'}</td>
                                                    <td style={{ padding: "12px", textAlign: "center" }}>
                                                        <span style={{
                                                            padding: "4px 8px",
                                                            borderRadius: "4px",
                                                            fontSize: "12px",
                                                            fontWeight: "500",
                                                            backgroundColor: log.first_status === 'W' ? "#fef3c7" : "#d1fae5",
                                                            color: log.first_status === 'W' ? "#92400e" : "#065f46"
                                                        }}>
                                                            {log.first_status === 'W' ? '대기' : log.first_status}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                            {splitHistory.map((log, index) => (
                                                <tr key={`second-${index}`} style={{ borderBottom: "1px solid #e5e7eb" }}>
                                                    <td style={{ padding: "12px", fontWeight: "500", color: "#1e40af" }}>두 번째</td>
                                                    <td style={{ padding: "12px" }}>{log.second_co_nm || '-'}</td>
                                                    <td style={{ padding: "12px" }}>{getBankName(log.second_bank_code)}</td>
                                                    <td style={{ padding: "12px" }}>{log.second_account_number || '-'}</td>
                                                    <td style={{ padding: "12px", textAlign: "right", fontWeight: "500" }}>{changeNum(log.second_amount)}원</td>
                                                    <td style={{ padding: "12px" }}>{log.second_memo || '-'}</td>
                                                    <td style={{ padding: "12px", textAlign: "center" }}>
                                                        <span style={{
                                                            padding: "4px 8px",
                                                            borderRadius: "4px",
                                                            fontSize: "12px",
                                                            fontWeight: "500",
                                                            backgroundColor: log.second_status === 'W' ? "#fef3c7" : "#d1fae5",
                                                            color: log.second_status === 'W' ? "#92400e" : "#065f46"
                                                        }}>
                                                            {log.second_status === 'W' ? '대기' : log.second_status}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div style={{
                                    textAlign: "center",
                                    padding: "40px", 
                                    color: "#6b7280",
                                    backgroundColor: "#f9fafb",
                                    borderRadius: "6px"
                                }}>
                                    분할 이력이 없습니다.
                                </div>
                            )}
                        </div>

                        <div className="modal-footer" style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            paddingTop: "20px",
                            borderTop: "1px solid #e5e7eb",
                            marginTop: "20px"
                        }}>
                            <button 
                                className="btn btn-secondary" 
                                onClick={() => setSplitHistoryModal(false)}
                                style={{
                                    padding: "8px 16px",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9fafb",
                                    color: "#374151",
                                    cursor: "pointer"
                                }}
                            >
                                닫기
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

const Excel = (excelData) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = '입금예정 가맹점내역';

    const headerRow = [
        "정산일", "MID", "가맹점명", "정산액", "최종 입금 예정액", "예금주", "입금계좌", "은행", "지갑", "적요"
    ];

    const bodyRows = excelData.map((data) => ([
        data.정산일, data.MID, data.가맹점명, Number(data.정산액), Number(data["최종 입금 예정액"]), data.예금주, data.입금계좌, data.은행, data.지갑, data.적요
    ]));

    const sheetData = [headerRow, ...bodyRows];
    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    ws['!cols'] = Array(headerRow.length).fill({ wpx: 100 });

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelBuffer], { type: excelFileType });

    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};

export default SettlementDepositStay